import { API_URL } from './api';
import { pulseCashDrawer } from './thermalPrinter';
import { operationalScope } from './workstationIdentity';

const consumed = new Set();
export function paymentIncludesCash(method, splits = []) {
  return ['cash', 'espece', 'especes'].includes(method) || (method === 'mixte' && splits.some(row => ['cash', 'espece', 'especes'].includes(row.method) && Number(row.amount) > 0));
}

// The server grants a localAction once. Never queue, fetch again or retry a pulse.
export async function consumeDrawerOperation(operation, fetchWithAuth, scope = operationalScope()) {
  if (!operation) return '';
  const fallback = operation.message || (operation.state === 'submitted' ? 'Commande du tiroir envoyée. Vérifiez son ouverture.' : 'Ouverture du tiroir à vérifier.');
  if (!operation.localAction) return fallback;
  const key = `${scope}:${operation.id}`;
  if (!operation.id || consumed.has(key)) return fallback;
  consumed.add(key);
  let state = 'uncertain';
  try {
    if (scope !== operationalScope()) return 'Poste modifié : tiroir non commandé. Vérifiez le poste d’origine.';
    await pulseCashDrawer(operation.localAction, { isCurrent: () => scope === operationalScope() });
    state = 'submitted';
  } catch (error) { state = error?.drawerState === 'failed' ? 'failed' : 'uncertain'; /* Never retry a physical action. */ }
  try {
    if (scope !== operationalScope()) return 'Poste modifié : résultat du tiroir à vérifier.';
    const response = await fetchWithAuth(`${API_URL}/api/cash-register/drawer/${encodeURIComponent(operation.id)}/ack`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ state }),
    });
    if (!response.ok) throw new Error('ack');
  } catch (_) { return 'Résultat du tiroir non confirmé au serveur. Vérifiez-le avant toute nouvelle ouverture.'; }
  return state === 'failed' ? 'Tiroir non commandé. Vérifiez sa configuration avant une nouvelle demande.' : state === 'submitted' ? 'Commande du tiroir envoyée. Vérifiez son ouverture.' : 'Ouverture du tiroir incertaine. Vérifiez-le avant toute nouvelle ouverture.';
}
